import { Component, EventEmitter, OnInit, style, ViewChild, OnDestroy, HostListener } from '@angular/core';
import { CurrentPageWatcherService, UserData } from './shared/utils/CurrentPageWatcher';
import { LoginComponent } from './login/login/login.component';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { LoginService } from './login/login/login.service';
import { filter } from 'rxjs/operators';
import { AuthenticationService } from './shared/security/AuthenticationService';
import { LogoutUserResponseModel, ValidateUserResponseModel, RequiredInformationModel } from './model/models';
import { SpinnerService } from './shared/spinner/spinner.service';
import { Subscription } from 'rxjs';
import * as $ from 'jquery';
import { ChangeEmployerService } from './broker/change-employer/change-employer.service';
import { WorkflowStepModel } from './model/workflowStepModel';
import { StartFunctionResponseModel } from './model/startFunctionResponseModel';
import { WorkflowModel } from './model/workflowModel';
import { IdleService } from './shared/idle/idle.service';
import { StartFunctionService } from './shared/utils/start-function.service';
import { StorageService } from './shared/security/StorageService';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit,OnDestroy{
 
  currentPageTitle: string;
  stepsTitle : string = "Steps";
  servicesTitle : string ="Services"
  appName = 'Arizona Department Of Real Estate';
  depName = 'Real Estate Licensing';
  userName : string;
  licenseNumber : string;

  connectedUserInfoSubscription : Subscription;
  startFunctionBrokerRespSubscription : Subscription;
  stepInprogressSubscription : Subscription;
  stepsMenuDisplay : boolean = false;
  workflow : WorkflowModel =null;
  stepIndex : number = -1;
  stepInprogressType : number=-1;
  checkedStep : string ="";
  lastStep : boolean =false;
  public now: Date = new Date();
  currentYear: number ;

   public isConnected: boolean = false;

  notificationOptions = {
    position: ["top", "right"],
    timeOut: 5000,
    lastOnBottom: true

  };

  constructor(
    //private idle : IdleService,
    private loginService: LoginService,
    private currentPageWatcher: CurrentPageWatcherService,
    private router: Router,
    private authenticationService : AuthenticationService,
    private titleService: Title,
    private startFunctionService : StartFunctionService,
    private storageService :StorageService) {
      this.currentYear = this.now.getFullYear();
      this.lastStep = this.currentPageWatcher.lastStep;
      this.currentPageWatcher.notifyConnectedUser().subscribe(connected=>this.isConnected=connected);
      if(this.storageService.getSessionData() && this.storageService.getSessionData().userData !=null && this.storageService.getSessionData().userData!= undefined){
        this.licenseNumber = this.storageService.getSessionData().userData.licenseNumber;
      }
  }

  ngOnInit() {
    this.startFunctionBrokerRespSubscription = this.startFunctionService.getStartFunctionBrokerResp()
    .subscribe((startFunctionResp : StartFunctionResponseModel)=>{
      console.log("startFunctionResp===========> ",startFunctionResp);
      this.lastStep = false;
   
      if(startFunctionResp !=null && startFunctionResp!=undefined && startFunctionResp.Workflow!=null){
      this.stepInprogressType=startFunctionResp.Workflow.Steps.filter(el=>el.checked==false)[0].WorkflowStepType;
      this.stepsMenuDisplay =  true;
      this.workflow = startFunctionResp.Workflow;
      
      console.log("employerWorkflowSteps : ",   this.workflow);
      //increment step
      this.currentPageWatcher.sendStepMessage(startFunctionResp.Workflow.Steps[0].StepMessage);
    }
    });

  //if user is connected (page initialized from scs) , get workflow informations from localstorage
if(this.workflow == null && this.storageService.getStartFunctionData()!=null){
  this.isConnected = true;
  this.workflow = this.storageService.getStartFunctionData().Workflow;
  this.stepInprogressType = this.workflow.Steps.filter(el=>el.checked==false)[0].WorkflowStepType;
  this.stepsMenuDisplay =  true;
  this.userName = this.storageService.getSessionData().userData.name;
  this.licenseNumber = this.storageService.getSessionData().userData.licenseNumber;
  // this.lastStep = true;

}
  this.stepInprogressSubscription = this.startFunctionService.getNotifyStepInProgress().subscribe(step=>{
    console.log("step resp ${step}", step);
    this.lastStep = false;
    this.currentPageWatcher.sendStepMessage(null);
    let startFunction = this.storageService.getStartFunctionData();
    if(startFunction.Workflow !=null && startFunction.Workflow!=undefined){
    if (step == true) {
     
      startFunction.Workflow.Steps.filter(el=>el.checked==false)[0].checked=true;

    
      
    }
   if (step == false){
     let length = startFunction.Workflow.Steps.filter(el=>el.checked==true).length;
   
    startFunction.Workflow.Steps.filter(el=>el.checked==true)[length-1].checked=false;

    }
    console.log("startFunction in localstorage ", startFunction);
    this.storageService.setStartFunctionData(startFunction);
    this.workflow=startFunction.Workflow;
    this.stepInprogressType = startFunction.Workflow.Steps.filter(el=>el.checked==false)[0].WorkflowStepType;
   //check if last step (receipt step)
    if(startFunction.Workflow.Steps.filter(el=>el.checked==false).length == 1){
      this.lastStep = true;
    }
    //step message will be displayed from receipt component
      this.currentPageWatcher.sendStepMessage(startFunction.Workflow.Steps.filter(el=>el.checked==false)[0].StepMessage);
    }
   
});
  
    this.currentPageWatcher.pageChanged().subscribe(pageTitle => this.currentPageTitle = pageTitle);
    this.currentPageWatcher.notifyLeftMenuDisplay().subscribe(menuDisplay=>this.stepsMenuDisplay=menuDisplay);
    
    this.connectedUserInfoSubscription = this.currentPageWatcher.notifyConnectedUserInfo().subscribe(userData =>{
      if(userData!=null){
        this.isConnected=true;
      this.userName = userData.name;
      this.licenseNumber = userData.licenseNumber;
    }
    });

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)      
  ).subscribe((event : NavigationEnd) => {
  if((event.url!="/faq#q01" ) && (event.url!="/faq#q02")){
  $("html, body").animate({ scrollTop: 0 }, "slow");
 }
});

   // this.configService.loadConfig().subscribe(
    //  (configMap: AzMap<string, string>) => {

   //     this.configMap = configMap;

        //example usage:

 //       this.appName = configMap.get("app/name");
 //       this.depName = configMap.get("dep/name");
        
        this.loginService.onLogin.subscribe(
          (userInfo : ValidateUserResponseModel) => {
            this.licenseNumber = userInfo.LicenseNo;
            let sessionData = this.storageService.getSessionData();
            sessionData.userData = new UserData(null, this.licenseNumber);

            this.storageService.setSessionData(sessionData);
            this.handleLoginSuccess(userInfo.UserID);


       }
       );
    /* //Start watching for user inactivity.
    this.userIdle.startWatching();
    // Start watching when user idle is starting and reset if user action is there.
    this.userIdle.onTimerStart().subscribe(count => {
      var eventList = ["click", "mouseover", "keydown", "DOMMouseScroll", "mousewheel",
        "mousedown", "touchstart", "touchmove", "scroll", "keyup"];
      for (let event of eventList) {
        document.body.addEventListener(event, () => this.userIdle.resetTimer());
      }
    });
    // Start watch when time is up.
    this.userIdle.onTimeout().subscribe(() => {
      //alert("Your session has expired click on OK to resume the application.");
      this.logout();
    })
 */
  }
  handleLoginSuccess(userID: number): void {

    this.loginService.getRequiredUserInformation(userID).subscribe((resp:RequiredInformationModel)=>{
      if(resp.EmailAddress==true){
        //navigate to email ...
        this.isConnected = true;
        this.router.navigate(['/emailAddress']);
      }
      else{
        this.isConnected = true;
        this.router.navigate(['/home']);
      }
    })
          
  }
 
  logout() {
    this.currentPageWatcher.clearUserMessage();
    this.stepsMenuDisplay =  false;
    this.isConnected = false;
    this.loginService.logoutUser()
    .subscribe((response : LogoutUserResponseModel)=>{
      console.log(response.SystemMessage);
      // if(response.SystemMessage==null){
          this.authenticationService.logout();

      // }

  });
  }

  goToAzWebsite(){
    
  }

  onStepSubmit(step){
    console.log(" submited step !! ", step);
    console.log(" workflow id : ", this.workflow.WorkflowID);
    console.log(" current step index : ", this.workflow.CurrentStepIndex);
  }


  ngOnDestroy(): void {
    this.connectedUserInfoSubscription.unsubscribe();
   this.startFunctionBrokerRespSubscription.unsubscribe();
  //  this.stepInprogressSubscription.unsubscribe();
    this.storageService.clear();
    this.currentPageWatcher.clearStepMessage();

  }
  goToHome(){
    this.currentPageWatcher.clearUserMessage();
  }
  
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts